import React from "react";
import Container from "./Container";
import { COMPANY_INFO, CTA_URL, IMAGES, NAV_LINKS } from "../constants";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="bg-text-primary text-white py-16 pb-24 md:pb-16"
      role="contentinfo"
    >
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <img
              src={IMAGES.logo}
              alt={`${COMPANY_INFO.name} logo`}
              className="h-11 w-auto mb-5"
            />
            <p className="text-white/75 leading-relaxed">
              Operacion profesional en destino para programas juveniles
              internacionales.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">
              Navegacion
            </h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    className="text-white/75 hover:text-white transition-colors link-underline focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={CTA_URL}
                  className="text-white/75 hover:text-white transition-colors link-underline focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
                >
                  Solicitar acceso
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Contacto</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${COMPANY_INFO.email}`}
                  className="text-white/75 hover:text-white transition-colors"
                >
                  {COMPANY_INFO.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${COMPANY_INFO.phone}`}
                  className="text-white/75 hover:text-white transition-colors"
                >
                  {COMPANY_INFO.phone}
                </a>
              </li>
              <li className="text-white/75">{COMPANY_INFO.address}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/15 mt-12 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-sm text-white/60">
            {currentYear} {COMPANY_INFO.name}. Todos los derechos reservados.
          </p>
          <p className="text-sm text-accent font-medium">
            No vendemos al cliente final. Trabajamos exclusivamente con
            agencias.
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
